function moveRebuyCart() {
  const rebuyCart = document.getElementById('rebuy-cart');
  const mainContent = document.getElementById('MainContent');

  if (rebuyCart && mainContent) {
    mainContent.appendChild(rebuyCart);
    observer.disconnect();
  }
}

const observer = new MutationObserver(mutations => {
  moveRebuyCart();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

moveRebuyCart();